
import React, { useState } from 'react';

interface ApiKeyDisplayProps {
  apiKey: string;
  className?: string;
}

export const ApiKeyDisplay: React.FC<ApiKeyDisplayProps> = ({ apiKey, className = '' }) => {
  const [copied, setCopied] = useState(false);
  
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(apiKey);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      
    }
  };
  
  return (
    <span 
      className={`api-key-display ${className}`}
      onClick={handleCopy}
      title="Click to copy API key"
    >
      {apiKey}
      {copied && (
        <div className="api-key-tooltip">
          Copied!
        </div>
      )}
    </span>
  );
};

export default ApiKeyDisplay;